import ServicePage from '@/components/ServicePage';

export default function CloudServicesPage() {
  return (
    <ServicePage
      slug="cloud-services"
      title="Cloud Services & Migration"
      titleAr="الخدمات السحابية والترحيل"
      description="Expert cloud migration, infrastructure setup, and management services for Egyptian businesses. We help you move to AWS, Azure, or Google Cloud with zero downtime and optimized costs."
      descriptionAr="خدمات ترحيل سحابي خبيرة، وإعداد البنية التحتية، والإدارة للشركات المصرية. نساعدك في الانتقال إلى AWS أو Azure أو Google Cloud بدون توقف وتكاليف محسنة."
      keywords="cloud migration services Egypt, AWS cloud services, Azure migration, Google Cloud Platform, cloud infrastructure, cloud computing solutions, cloud management"
      heroImage="https://readdy.ai/api/search-image?query=Cloud%20computing%20infrastructure%20and%20data%20center%20visualization%2C%20abstract%20server%20network%20with%20glowing%20nodes%2C%20blue%20and%20white%20digital%20technology%20background%2C%20professional%20futuristic%20concept%2C%20clean%20modern%20design%2C%20Egyptian%20tech%20business%20context&width=1400&height=600&seq=svc3&orientation=landscape"
      icon="ri-cloud-line"
      features={[
        {
          title: 'Cloud Migration',
          titleAr: 'الترحيل السحابي',
          description: 'We migrate your applications and data from on-premise servers to the cloud with minimal downtime. Our phased approach ensures business continuity throughout.',
          descriptionAr: 'نرحل تطبيقاتك وبياناتك من الخوادم المحلية إلى السحابة مع الحد الأدنى من التوقف. يضمن نهجنا المرحلي استمرارية الأعمال على طول الطريق.',
        },
        {
          title: 'Infrastructure Setup',
          titleAr: 'إعداد البنية التحتية',
          description: 'We design and implement cloud infrastructure using Infrastructure as Code (IaC). Automated provisioning, configuration management, and environment replication.',
          descriptionAr: 'نصمم وننفذ البنية التحتية السحابية باستخدام Infrastructure as Code (IaC). التزويد الآلي، وإدارة التكوين، ونسخ البيئة.',
        },
        {
          title: 'Auto-Scaling & Load Balancing',
          titleAr: 'التوسع التلقائي وموازنة الحمل',
          description: 'Implement auto-scaling groups and load balancers that handle traffic spikes automatically. Pay only for what you use, scale when you need it.',
          descriptionAr: 'تنفيذ مجموعات التوسع التلقائي وموازنات الحمل التي تتعامل مع ارتفاعات حركة المرور تلقائياً. ادفع فقط مقابل ما تستخدمه، وتوسع عندما تحتاج إليه.',
        },
        {
          title: 'Cloud Monitoring & Alerting',
          titleAr: 'المراقبة السحابية والتنبيه',
          description: '24/7 monitoring with dashboards, alerts, and automated incident response. We track CPU, memory, disk, network, and application-level metrics.',
          descriptionAr: 'المراقبة على مدار الساعة مع لوحات المعلومات، والتنبيهات، والاستجابة الآلية للحوادث. نتتبع مقاييس CPU والذاكرة والقرص والشبكة ومستوى التطبيق.',
        },
        {
          title: 'Disaster Recovery & Backup',
          titleAr: 'الاسترداد من الكوارث والنسخ الاحتياطي',
          description: 'Automated backup strategies with point-in-time recovery, cross-region replication, and tested disaster recovery plans. Your data is never lost.',
          descriptionAr: 'استراتيجيات نسخ احتياطي آلي مع الاسترداد في نقطة الوقت، والنسخ المتماثل عبر المناطق، وخطط استرداد الكوارث المختبرة. بياناتك لا تضيع أبداً.',
        },
        {
          title: 'Cost Optimization',
          titleAr: 'تحسين التكاليف',
          description: 'We analyze your cloud spend, identify waste, and implement reserved instances, spot instances, and resource scheduling to reduce bills by up to 40%.',
          descriptionAr: 'نحلل إنفاقك السحابي، ونحدد الهدر، وننفذ مثيلات محجوزة، ومثيلات spot، وجدولة الموارد لتقليل الفواتير بنسبة تصل إلى 40٪.',
        },
      ]}
      benefits={[
        {
          title: 'Zero Downtime Migration',
          titleAr: 'ترحيل بدون توقف',
          description: 'Our blue-green deployment strategy and database replication ensure your users never experience interruption during migration.',
          descriptionAr: 'تضمن استراتيجية النشر الأزرق-الأخضر ونسخ قاعدة البيانات ألا يواجه مستخدموك انقطاعاً أثناء الترحيل.',
        },
        {
          title: 'Certified Cloud Engineers',
          titleAr: 'مهندسون سحابيون معتمدون',
          description: 'Our team holds AWS Solutions Architect, Azure Administrator, and Google Cloud Professional certifications. Expert-level infrastructure design.',
          descriptionAr: 'يحمل فريقنا شهادات AWS Solutions Architect، و Azure Administrator، و Google Cloud Professional. تصميم بنية تحتية على مستوى خبير.',
        },
        {
          title: 'Security First',
          titleAr: 'الأمان أولاً',
          description: 'We implement security groups, IAM policies, encryption at rest and in transit, VPC isolation, and compliance with industry standards.',
          descriptionAr: 'ننفذ مجموعات الأمان، وسياسات IAM، والتشفير في حالة السكون والنقل، وعزل VPC، والامتثال لمعايير الصناعة.',
        },
        {
          title: 'Ongoing Management',
          titleAr: 'إدارة مستمرة',
          description: 'Post-migration, we offer managed cloud services including patching, optimization, security audits, and 24/7 support. We become your cloud team.',
          descriptionAr: 'بعد الترحيل، نقدم خدمات سحابية مدارة بما في ذلك التصحيح، والتحسين، وتدقيقات الأمان، والدعم على مدار الساعة. نصبح فريقك السحابي.',
        },
      ]}
      faqs={[
        {
          question: 'Which cloud platform is best for my business?',
          questionAr: 'ما هي المنصة السحابية الأفضل لعملي؟',
          answer: 'AWS offers the widest service catalog and global reach. Azure integrates best with Microsoft ecosystems. Google Cloud excels at AI/ML and analytics. We recommend based on your specific requirements, existing tech stack, and budget.',
          answerAr: 'تقدم AWS أوسع كتالوج خدمات ووصول عالمي. يتكامل Azure بشكل أفضل مع أنظمة Microsoft. يتفوق Google Cloud في الذكاء الاصطناعي/التعلم الآلي والتحليلات. نوصي بناءً على متطلباتك المحددة، والمكدس التقني الحالي، والميزانية.',
        },
        {
          question: 'How long does cloud migration take?',
          questionAr: 'كم يستغرق الترحيل السحابي؟',
          answer: 'Simple lift-and-shift migrations take 2-4 weeks. Complex multi-tier applications with database migration take 6-12 weeks. We plan carefully to minimize risk and business impact.',
          answerAr: 'يستغرق الترحيل السحابي البسيط 2-4 أسابيع. تستغرق التطبيقات متعددة الطبقات المعقدة مع ترحيل قاعدة البيانات 6-12 أسبوعاً. نخطط بعناية لتقليل المخاطر والتأثير على الأعمال.',
        },
        {
          question: 'Will my cloud costs go down after migration?',
          questionAr: 'هل ستنخفض تكاليف السحابة بعد الترحيل؟',
          answer: 'Most clients see 20-40% cost reduction after optimization, compared to on-premise hardware and maintenance. However, poorly managed cloud resources can be expensive. Our cost optimization service ensures you spend wisely.',
          answerAr: 'يرى معظم العملاء تخفيضاً في التكاليف بنسبة 20-40٪ بعد التحسين، مقارنة بالأجهزة المحلية والصيانة. ومع ذلك، يمكن أن تكون الموارد السحابية المدارة بشكل سيء مكلفة. تضمن خدمة تحسين التكاليف لدينا أن تنفق بحكمة.',
        },
      ]}
      relatedServices={[
        { slug: 'custom-development', title: 'Custom Development', titleAr: 'التطوير المخصص', icon: 'ri-code-s-slash-line' },
        { slug: 'performance-optimization', title: 'Performance Optimization', titleAr: 'تحسين الأداء', icon: 'ri-speed-line' },
        { slug: 'workplace-automation', title: 'Workplace Automation', titleAr: 'أتمتة مكان العمل', icon: 'ri-settings-3-line' },
      ]}
    />
  );
}